import React, { Component } from "react";

export default class Eventos extends Component {
  state = {
    selectedImage: null,
  };

  openImage = (img) => {
    this.setState({ selectedImage: img });
  };

  closeImage = () => {
    this.setState({ selectedImage: null });
  };

  render() {
    // Genera arreglo del 1 al 90
    const images = Array.from({ length: 90 }, (_, i) =>
      `https://participacion-ciudadana.itetlax.org.mx/assets/img/actividades_ATCC_2026/${i + 1}.jpeg`
    );

    return (
      <div style={{ padding: "20px" }}>
        <h2>Eventos ATCC 2026</h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
            gap: "20px",
          }}
        >
          {images.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`evento-${index + 1}`}
              onClick={() => this.openImage(img)}
              style={{
                width: "100%",
                height: "250px",
                objectFit: "cover",
                borderRadius: "10px",
                cursor: "pointer",
                transition: "transform 0.3s",
              }}
              onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
              onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
              onError={(e) => (e.target.style.display = "none")} // Oculta si no existe
            />
          ))}
        </div>

        {/* Modal */}
        {this.state.selectedImage && (
          <div
            onClick={this.closeImage}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0,0,0,0.85)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
          >
            <img
              src={this.state.selectedImage}
              alt="ampliada"
              style={{
                maxWidth: "90%",
                maxHeight: "90%",
                borderRadius: "10px",
              }}
            />
          </div>
        )}
      </div>
    );
  }
}
